import * as React from 'react';

import { cn } from '@/lib/utils';

/** Rook inset material. Bordered because a standalone field needs an edge; drop
 *  `border-0 bg-transparent` on it when it sits inside an already-bordered
 *  container such as a dropdown or a toolbar. */
function Input({ className, type, ref, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        'flex h-7 w-full min-w-0 rounded-md border border-line-strong bg-wash-lighter px-2 text-base text-fg dark:border-line',
        'transition-[border-color] duration-100 outline-none',
        'placeholder:font-medium placeholder:text-fg-tertiary',
        'selection:bg-primary selection:text-primary-foreground',
        'file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-fg',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-fg-tertiary',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/40',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive/25',
        className
      )}
      {...props}
    />
  );
}

export { Input };
